import { render, staticRenderFns } from "./InputImageUpload.vue?vue&type=template&id=cefb7a26&scoped=true"
import script from "./InputImageUpload.vue?vue&type=script&lang=js"
export * from "./InputImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefb7a26",
  null
  
)

export default component.exports